import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { removeBlank } from 'src/app/core/helpers';
import { ApiService } from 'src/app/core/services/api.service';
@Injectable({
  providedIn: 'root'
})
export class PatientsService extends ApiService {
  public eventEmitter = new EventEmitter();
  public create(data): Observable<any> {
    return this.request({
      path: 'users',
      method: 'POST',
      body: data
    });
  }
  public createPatient(data): Observable<any> {
    return this.request({
      path: 'patients',
      method: 'POST',
      body: data
    });
  }

    public patch(data, id): Observable<any> {
    return this.request({
      path: `patients/${id}`,
      method: 'PATCH',
      body: data
    });
  }
  public getPatientList(param?): Observable<any> {
    return this.request({
      path: 'patients',
      method: 'GET',
      query: removeBlank(param)
    });
  }

    public getPatientDropdown(param?): Observable<any> {
    return this.request({
      path: 'patients/dropdown',
      method: 'GET',
      query: removeBlank(param)
    });
  }


  public getPatientWithTestsList(param?): Observable<any> {
    return this.request({
      path: 'patients/patient-with-tests',
      method: 'GET',
      query: removeBlank(param)
    });
  }
  public getUserById(id): Observable<any> {
    return this.request({
      path: `users/${id}`,
      method: 'GET'
    });
  }
  public getPatientById(id): Observable<any> {
    return this.request({
      path: `patients/${id}`,
      method: 'GET'
    });
  }
  public updateUser(data, id): Observable<any> {
    return this.request({
      path: `users/${id}`,
      method: 'PUT',
      body: data
    });
  }
  public updatePatients(data, id): Observable<any> {
    return this.request({
      path: `patients/${id}`,
      method: 'PUT',
      body: data
    });
  }
  public deleteUser(id): Observable<any> {
    return this.request({
      path: `users/${id}`,
      method: 'DELETE'
    });
  }
  public deletePatient(id): Observable<any> {
    return this.request({
      path: `patients/${id}`,
      method: 'DELETE'
    });
  }

  // update
}
